<!--
 * @author xuyiyuan
 * @date 2023-08-17 14:52
 * @description  业务组织
-->
<template>
  <lsTableLayout>
    <div slot="search">
      <lsSearchForm
        ref="searchForm"
        @reset="onSearch"
        @search="onSearch"
        :initExpand="false"
        :searchContentFold="false"
        :formList="formList"
      >
        <a-select slot="status" v-decorator="['status']" allowClear>
          <a-select-option v-for="item in STATUS_LIST" :key="item.key">{{ item.name }}</a-select-option>
        </a-select>
        <a-select slot="functionType" v-decorator="['functionType']" allowClear>
          <a-select-option v-for="item in functionTypeList" :key="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </lsSearchForm>
    </div>
    <div slot="table">
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        :scroll="{ fixScreen: true }"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.BUSINESS_ORGANIZATION_LIST, // 表格方案配置唯一值
              }"
      >
        <template slot="status" slot-scope="{ text }">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
        </template>
      </ls-api-table>
    </div>
  </lsTableLayout>
</template>

<script>
import { STATUS_LIST } from './enum'
import { listTSysBusinessOrganization, listFunctionType } from '@/api/system/businessOrganization'
import { generateLsTableResData } from '@/utils/util.js'

const statusMap = {
  2: {
    status: 'processing',
    text: '未启用'
  },
  1: {
    status: 'processing',
    text: '启用'
  },
  0: {
    status: 'default',
    text: '停用'
  }
}

export default {
  name: 'BusinessOrganization',
  components: {},
  data () {
    return {
      STATUS_LIST,
      formList: [
        {
          label: '组织编码',
          type: 'input',
          decorator: ['organizationNo'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '组织名称',
          type: 'input',
          decorator: ['organizationName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '状态',
          type: 'status',
          decorator: ['status']
        },
        {
          label: '职能类型',
          type: 'functionType',
          decorator: ['functionType']
        }
      ],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(listTSysBusinessOrganization, true),
        pageCurrent: true
      },
      // 表头
      columns: [
        {
          title: '组织编码',
          dataIndex: 'organizationNo'
        },
        {
          title: '组织名称',
          dataIndex: 'organizationName'
        },
        {
          title: '职能类型',
          dataIndex: 'functionType'
        },
        {
          title: '说明',
          dataIndex: 'remark',
          ellipsis: true
        },
        {
          title: '外部编码',
          dataIndex: 'externalCoding'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 100
        }
      ],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      functionTypeList: []
    }
  },
  created () {
    this.getFunctionTypeList()
  },
  mounted () {
    this.onSearch()
  },
  // 状态过滤
  filters: {
    statusFilter (type) {
      return statusMap[type].text
    },
    statusTypeFilter (type) {
      return statusMap[type].status
    }
  },
  methods: {
    getFunctionTypeList () {
      listFunctionType().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.realValue,
              value: element.label
            }
            list.push(obj)
          });
          this.functionTypeList = list;
        }
      })
    },
    // 表单搜索
    onSearch (values = {}) {
      const params = { ...values }
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    }
  }
}
</script>
